'use client';

/**
 * V2Layout - the v2 page shell.
 *
 * Wraps every v2 page with the new header + footer and owns the `.v2-root`
 * scope that activates the v2 design tokens / reset from src/styles/v2.css.
 *
 * Critically, V2Layout does NOT include MainLayout, ConnectSection, or any
 * legacy CSS. The page rendered inside it gets a clean canvas free of
 * Bootstrap and legacy global element styles.
 */

import V2Header from './V2Header';
import V2Footer from './V2Footer';

export default function V2Layout({ children }) {
  return (
    <div className="v2-root flex min-h-screen flex-col bg-white text-gray-950 antialiased">
      <V2Header />
      <main className="flex-1">{children}</main>
      <V2Footer />
    </div>
  );
}
